// Chainformation.Ccm.Core.TranslationStatus
export enum FiTranslationStatus {
    NotTranslated = 1,
    Translated = 2,
}

// note: not used ?
/*  todo not used, remove?
Chainformation.Ccm.Core.TranslationStatuses =
    [
        {Id:Chainformation.Ccm.Core.TranslationStatus.NotTranslated,TextId:458},
        {Id:Chainformation.Ccm.Core.TranslationStatus.Translated,TextId:459}
    ];

*/
